import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/img/404.png'


import { onMounted,ref } from "vue";
import MainHeader from "@/components/main-header.vue";
import { useHead } from "@vueuse/head";



export default /*@__PURE__*/_defineComponent({
  __name: 'NotFoundView',
  setup(__props) {

const SSRData = ref({
  title: "找不到页面",
  description: "",
  keywords:"宁波技术社区,默认代码,程序员中文技术社区,前端开发社区,前端技术交流,前端框架教程",
});

onMounted(async () => {
    setSSRHead();
});

//动态设置SEO 信息
const setSSRHead = () => {
  useHead({
    title: SSRData.value.title,
    meta: [
      { name: "description", content: SSRData.value.description },
      { name: "keywords", content: SSRData.value.keywords },
    ],
  });
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(MainHeader),
    _cache[0] || (_cache[0] = _createStaticVNode("<div class=\"empty-list\" data-v-2bcc14dd><div class=\"null-infor-list\" data-v-2bcc14dd><div class=\"content-flag\" data-v-2bcc14dd><div class=\"common-empty\" data-v-2bcc14dd><img src=\"" + _imports_0 + "\" data-v-2bcc14dd></div></div></div></div>", 1))
  ]))
}
}

})